import { testimonials } from '@/mocks/home';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            用户评价
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            听听用户怎么说
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            来自真实用户的使用反馈，JMTT用品质赢得信赖
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < item.rating ? 'ri-star-fill text-primary-500' : 'ri-star-fill text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-5">
                "{item.content}"
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <div className="font-heading font-semibold text-foreground-900 text-sm">
                    {item.name}
                  </div>
                  <div className="text-foreground-400 text-xs">
                    {item.role} · {item.date}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}